import type { ReactElement } from 'react';
import { type BaseButtonProps, Button } from '@repo/design-system-kit/components/button/button';
import styles from './responsive-cta.module.css';
import cx from 'clsx';

type ResponsiveCtaProps = Omit<BaseButtonProps, 'stretch'>;

export function ResponsiveCta({
  className,
  children,
  label,
  variant = 'primary',
  ...props
}: ResponsiveCtaProps): ReactElement {
  return (
    <Button
      {...props}
      label={label}
      stretch={false}
      variant={variant}
      className={cx(className, styles.responsiveCta)}
    >
      {children}
    </Button>
  );
}
